import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Aug 06 2018
 * @author VBr
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable, runInAction } from 'mobx';
import { RoundingRuleLayer } from '../../transportLayers/general-settings/RoundingRuleLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * This store obtaining data of products.
 */

export var RoundingRuleStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(RoundingRuleStore, _BaseStore);

  function RoundingRuleStore(rootStore) {
    var _this;

    _classCallCheck(this, RoundingRuleStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RoundingRuleStore).call(this, rootStore));
    /** Store name */

    _this.name = StoreName.RoundingRule;
    /** layer containes methods for fletching data */

    _this.roundingRuleLayer = new RoundingRuleLayer();
    /** List of rounding rules */

    _this.list = new Map();

    _this.create = function (roundingRule) {
      return _this.roundingRuleLayer.create(roundingRule).then(function (rule) {
        runInAction(function () {
          _this.list.set(rule.id, rule);
        });
      });
    };

    _this.update = function (roundingRule) {
      return _this.roundingRuleLayer.update(roundingRule).then(function (rule) {
        runInAction(function () {
          _this.list.set(rule.id, rule);
        });
      });
    };

    _this.delete = function (id) {
      return _this.roundingRuleLayer.delete(id).then(function () {
        runInAction(function () {
          _this.list.delete(id);
        });
      });
    };

    return _this;
  }
  /**
   * Fletches all Tiers
   * returns a promise with Map of all Tiers
   */


  _createClass(RoundingRuleStore, [{
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      return this.roundingRuleLayer.findAll().then(function (roundingRules) {
        runInAction(function () {
          roundingRules.forEach(function (roundingRule) {
            if (roundingRule.id) {
              _this2.list.set(roundingRule.id, roundingRule);
            }
          });
        });
      });
    }
  }, {
    key: "getOne",
    value: function getOne(roundingRuleId) {
      var _this3 = this;

      return this.roundingRuleLayer.findOne(roundingRuleId).then(function (roundingRule) {
        runInAction(function () {
          _this3.list.set(roundingRule.id, roundingRule);
        });
        return roundingRule;
      });
    }
  }]);

  return RoundingRuleStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], RoundingRuleStore.prototype, "list", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], RoundingRuleStore.prototype, "getAll", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], RoundingRuleStore.prototype, "getOne", null);

__decorate([action, __metadata("design:type", Object)], RoundingRuleStore.prototype, "create", void 0);

__decorate([action, __metadata("design:type", Object)], RoundingRuleStore.prototype, "update", void 0);

__decorate([action, __metadata("design:type", Object)], RoundingRuleStore.prototype, "delete", void 0);